export default __webpack_public_path__ + "static/media/branch.241d1dc2.svg";